import type { SxProps, Theme } from '@mui/material';

/** Keeps a picker's field out of sight while its popper opens from a list row. */
export const hiddenPickerSx: SxProps<Theme> = {
  visibility: 'hidden',
  position: 'absolute',
  opacity: 0,
  bottom: 0,
  zIndex: -1,
};
